export var AthenaEventSaveErrorReason;
(function (AthenaEventSaveErrorReason) {
    // Known errors returned by the EventStorage backend.
    AthenaEventSaveErrorReason["UniqueViolation"] = "UNIQUE_VIOLATION";
    AthenaEventSaveErrorReason["Validation"] = "VALIDATION";
    AthenaEventSaveErrorReason["Unauthorized"] = "UNAUTHORIZED";
    AthenaEventSaveErrorReason["Addition"] = "ADDITION";
    // Other errors
    AthenaEventSaveErrorReason["BackendUnreachable"] = "BACKEND_UNREACHABLE";
    AthenaEventSaveErrorReason["Unknown"] = "UNKNOWN";
})(AthenaEventSaveErrorReason || (AthenaEventSaveErrorReason = {}));
//# sourceMappingURL=AthenaEventSaveErrorReason.js.map